import { render, staticRenderFns } from "./BillAllocationAlready.vue?vue&type=template&id=b62b80ec&"
import script from "./BillAllocationAlready.vue?vue&type=script&lang=js&"
export * from "./BillAllocationAlready.vue?vue&type=script&lang=js&"
import style0 from "./BillAllocationAlready.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports